import qs from "qs";
import axios from "axios";
import { Dialog, Toast } from "vant";
import { REDIRECT_URI, APP_ID } from "../config/global.js";
axios.defaults.timeout = 30000; // 请求超时
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
// axios.defaults.withCredentials = true; // 允许跨域携带cookie
// axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
		let stoToken = "";
    // 获取localStorage 内token
		if (process.env.VUE_APP_TITLE == "production") {
			const token = localStorage.getItem("token");
			// const token = "%7B%22alg%22%3A%22HS256%22%2C%22typ%22%3A%22JWT%22%7D.%7B%22openid%22%3A%22ou_7dd43832a60de4b2b5679170929dad52%22%2C%22modbile%22%3A%22u-2Nhk4u44xbWrNYHGomWT9Ch5h16g4143i8000lA02LqP%22%2C%22expireTime%22%3A1653209853%7D.%257B%2522alg%2522%253A%2522HS256%2522%252C%2522typ%2522%253A%2522JWT%2522%257D%257B%2522openid%2522%253A%2522ou_7dd43832a60de4b2b5679170929dad52%2522%252C%2522modbile%2522%253A%2522u-2Nhk4u44xbWrNYHGomWT9Ch5h16g4143i8000lA02LqP%2522%252C%2522expireTime%2522%253A1653209853%257D111HS256";
			if (!isEmpty(token)) {
			  config.headers["Authorization"] = "Bearer " + token; // 如果token 存在则携带token访问
			}
			
			// 获取用户信息token
			stoToken = window.localStorage.getItem("sto_user_token");
		} else {
			stoToken = "%7B%22alg%22%3A%22HS256%22%2C%22typ%22%3A%22JWT%22%7D.%7B%22openid%22%3A%22ou_daea6d9d3472157d3e30e3e305a29842%22%2C%22modbile%22%3A%22u-cTezcwZc97ua8xmuaI4xj11hieHAglLzoW005hiwwCMz%22%2C%22expireTime%22%3A1726387694%7D.%257B%2522alg%2522%253A%2522HS256%2522%252C%2522typ%2522%253A%2522JWT%2522%257D%257B%2522openid%2522%253A%2522ou_daea6d9d3472157d3e30e3e305a29842%2522%252C%2522modbile%2522%253A%2522u-cTezcwZc97ua8xmuaI4xj11hieHAglLzoW005hiwwCMz%2522%252C%2522expireTime%2522%253A1726387694%257D111HS256";
		}
    
    console.log(stoToken);
    if (stoToken) {
      config.headers["token"] = stoToken;
    }

    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(res) {
    // sto    token失效
    if (res.data.code == 10401) {
      if (window.h5sdk) {
        // 为飞书环境静默授权登录
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        window.localStorage.removeItem("sto_user_token");
        window.localStorage.setItem("redirect_url", window.location.href);
        window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${REDIRECT_URI}&app_id=${APP_ID}`;
      } else {
        Dialog.confirm({
          title: "身份失效",
          message: "身份信息失效，请重新授权登陆",
        })
          .then(() => {
            window.localStorage.removeItem("sto_user_token");
            window.localStorage.setItem("redirect_url", window.location.href);
            window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${REDIRECT_URI}&app_id=${APP_ID}`;
          })
          .catch(() => {
            window.localStorage.removeItem("sto_user_token");
          });
      }
      return;
    }

    if (res.data.code == 10403) {
      Dialog.alert({
        title: "权限不足",
        message: res.data.msg,
      }).then((res) => {
        // console.log(res)
        // window.location.href = REDIRECT_URI
      });
      return Promise.reject(res);
    }

    return res;
  },
  function(err) {
    if (err.data.code == 401 && err.data.msg == "generate access_token fail") {
      window.localStorage.removeItem("sto_user_token");
      window.localStorage.setItem("redirect_url", window.location.href);
      window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${REDIRECT_URI}&app_id=${APP_ID}`;
    }
    if (err.response.data.code == 401) {
      Toast(err.response.data.msg);
    }
    // 对响应错误做点什么
    return Promise.reject(err);
  }
);

/*对象转json*/
export function toJson(data) {
  var json = qs.stringify(data);
  return json;
}

/*判断是否为空*/
export function isEmpty(str) {
  if (str === "" || str === null || str === undefined) {
    return true;
  }
  return false;
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
//Vue.use(axios)
